module.exports = __webpack_public_path__ + "img/zuijia_16.f59d1602.png";